module.exports = __webpack_public_path__ + "static/img/content10.c35fcc8e.png";